import { render } from "./BaseEmptyEventState.vue?vue&type=template&id=09d37b38&scoped=true"
import script from "./BaseEmptyEventState.vue?vue&type=script&lang=js"
export * from "./BaseEmptyEventState.vue?vue&type=script&lang=js"

import "./BaseEmptyEventState.vue?vue&type=style&index=0&id=09d37b38&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d37b38"]])

export default __exports__